<template>
  <div id="app">
    <!-- <v-app> -->
      <keep-alive  v-if="$route.meta.keepAlive" >
        <router-view :key="$route.name"></router-view>
      </keep-alive>
      <router-view v-else></router-view>
    <!-- </v-app> -->
  </div>
</template>

<script>
  // import sidebarJS from './../assets/js/frontend.js'
  export default {
    name: 'App',
    data () {
      return {
        section: 'Head'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?6e3b6150